<template lang="pug">
  .announcement
    .sub-page-padding
      .container
        article.article-content
          //- pre {{ post }}
          h1 {{ post.title }}
          template(v-if="!$store.state.user.authenticated")
            LoginRequired.login-margin
          div.m-t-50.text-center(v-else-if="post.answered")
            //- 回答済みで且つ直接回答済みのアンケートURLを叩いて来た方に対して一覧に戻ってもらう為のリンク
            h3 {{$t("回答済")}}
            router-link.m-t-50(:to="{ name: 'surveys' }") {{$t("一覧に戻る")}}
          template(v-else-if="$store.state.user.authenticated")
            router-view(:post = 'post')
</template>

<script>
import LoginRequired from '@/components/LoginRequired'

export default {
  name: 'Survey',
  components: {
    LoginRequired,
  },
  data() {
    return {
      post: {},
    }
  },
  created() {
    this.api('getQuestionnaireById', { questionnaireID: this.$route.params.id }, rv => {
      if (!rv || !rv.succeed) {
        this.$router.push({
          path: '/notFound',
        })
      } else {
        this.post = rv
        this.lf2Br()
      }
    })
  },
  methods: {
    lf2Br() {
      this.post.body.forEach(({ question }, index) => {
        this.post.body[index].question = question.replace(/\n/g, '<br/>')
      })
    },
  },
}
</script>

<style lang="scss">
.login-required.login-margin {
  margin-top: 90px;
}
</style>
